export const baseUrl = import.meta.env.VITE_BAGEL_BUILD_ENV === 'dev' ? 'http://localhost:5173' : 'https://auctentic.com'

export const paramToCol: Record<string, string> = {
	related_catgory: 'blogCategories',
	category: 'blogCategories',
	article_slug: 'blog',
	product_slug: 'products',
	legal_slug: 'legalPages',
	// sell_slug: 'sellSafely',
	event_slug: 'events',
	sell_slug: 'sellPageBlocks',
}
